import { $history, createRequestStore, isDevelopment } from '@rst/libs-ts'
import { combine, forward, sample, Store } from 'effector'
import { withBaseSiteUrl } from '../lib/with-url'
import { RenderBlock } from '@rst/render-blocks/src/types'
import { $locale } from './init'
import { $connectedLangs } from './l10n'

const $historyPathname = sample({
	clock: $history,
	source: $connectedLangs,
	fn: (langs, { pathname }) => {
		if (isDevelopment) {
			if (
				/^\/\w\w(\/|$)/i.test(pathname) &&
				langs.includes(pathname.slice(1, 3))
			) {
				return pathname.slice(3)
			}
			return pathname
		} else {
			if (
				window.__setting__?.lang_setting?.type === 'path' &&
				/^\/\w\w(\/|$)/i.test(pathname) &&
				langs.includes(pathname.slice(1, 3))
			) {
				return pathname.slice(3)
			}

			return pathname
		}
	},
})

const {
	fx,
	$combined: $page,
	$store: $pageCore,
} = createRequestStore<void, { path: string; lang?: string }, RenderBlock.Page>(
	{
		url: withBaseSiteUrl('/api/page'),
		params: combine(
			{ path: $historyPathname, lang: $locale },
			({ lang, path }) => (lang === 'ru' ? { path } : { lang, path })
		),
	},
	window.__page__ || null
)

// @ts-ignore
const $pagePath: Store<string> = $page.map(({ data }) => data?.path)

forward({ from: $historyPathname, to: fx.prepend(() => undefined) })
if (!window.__page__) {
	fx()
}

const $isMainPage = $historyPathname.map(x => x === '/')

export { $page, $pageCore, $pagePath, $historyPathname, $isMainPage }
